/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { MdCategory } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import PropTypes from 'prop-types';

import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';

import CardSideBordered from '~/components/CardSideBordered';
import LocaleMessage from '~/components/LocaleMessage';
import PageContent from '~/components/PageContent';

import history from '~/services/history';
import api from '~/services/pluginbot-api';
import { expireSession } from '~/store/modules/auth/actions';

export default function ArticleCategoryForm(props) {
    const dispatch = useDispatch();
    const { match } = props;

    const category_id = match.params.id;
    const [operation, setOperation] = useState('create');

    const [categories, setCategories] = useState([]);
    const [body, setBody] = useState({
        name: '',
        parent_id: '',
    });

    const [isLoading, setIsLoading] = useState(true);
    const [forbidden, setForbidden] = useState(false);

    function requestError(error) {
        if (error.response) {
            const message = (
                <LocaleMessage msg={`errors.${error.response.data.code}`} />
            );
            const { status } = error.response;
            if (status === 401) {
                dispatch(expireSession());
            } else if (status === 403) {
                setForbidden(true);
            }
            toast.error(message);
        } else if (error.request) {
            toast.error(<LocaleMessage msg="errors.request" />);
        } else {
            toast.error(<LocaleMessage msg="errors.unknown" />);
        }
        setIsLoading(false);
    }

    async function loadCategories() {
        await api
            .get(`admin/articles/categories?flat=true`)
            .then(response => {
                const list = response.data
                    .filter(c => c.id !== category_id && !c.parent)
                    .map(c => ({
                        value: c.id,
                        label: c.name,
                    }));
                setCategories(list);
            })
            .catch(error => requestError(error));
    }

    async function loadCategory(_id) {
        if (_id === 'new') {
            setOperation('create');
            setIsLoading(false);
        } else {
            setOperation('update');
            await api
                .get(`admin/articles/categories/${_id}`)
                .then(response => {
                    const c = response.data;
                    setBody({
                        name: c.name || '',
                        parent_id: c.parent ? c.parent.id : '',
                    });
                })
                .catch(error => requestError(error));
            setIsLoading(false);
        }
    }

    useEffect(() => {
        loadCategories();
    }, []);

    useEffect(() => {
        loadCategory(category_id);
    }, [category_id]);

    async function handleSubmit(event) {
        event.preventDefault();
        setIsLoading(true);

        const data = {
            name: body.name,
            parent_id: body.parent_id || null,
        };

        if (operation === 'create') {
            await api
                .post(`admin/articles/categories`, data)
                .then(() => {
                    toast.success(
                        <LocaleMessage msg="page.articles.categories.form.create_success" />
                    );
                    history.push(`/articles/categories`);
                })
                .catch(error => requestError(error));
        } else {
            await api
                .put(`admin/articles/categories/${category_id}`, data)
                .then(() => {
                    toast.success(
                        <LocaleMessage msg="page.articles.categories.form.update_success" />
                    );
                    loadCategory(category_id);
                })
                .catch(error => requestError(error));
        }

        setIsLoading(false);
    }

    return (
        <PageContent
            title={
                operation === 'create' ? (
                    <LocaleMessage msg="page.articles.categories.form.create.title" />
                ) : (
                    <LocaleMessage msg="page.articles.categories.form.edit.title" />
                )
            }
            currentPage={
                operation === 'create' ? (
                    <LocaleMessage msg="page.articles.categories.form.create.title" />
                ) : (
                    <LocaleMessage msg="page.articles.categories.form.edit.title" />
                )
            }
            breadcrumbs={[
                {
                    url: '/articles',
                    title: <LocaleMessage msg="breadcrumbs.articles" />,
                },
                {
                    url: '/articles/categories',
                    title: (
                        <LocaleMessage msg="breadcrumbs.article_categories" />
                    ),
                },
            ]}
            loading={isLoading}
            forbidden={forbidden}
        >
            <>
                <div className="row full-body">
                    <div className="col-md-8 col-12 mb-5">
                        <form noValidate autoComplete="off">
                            <CardSideBordered
                                title={
                                    <LocaleMessage msg="page.articles.categories.form.label.settings" />
                                }
                                Icon={MdCategory}
                            >
                                <>
                                    <div className="row">
                                        <div className="col-md-6 col-12 mb-5">
                                            <TextField
                                                id="category-name"
                                                label={
                                                    <LocaleMessage msg="page.articles.categories.form.label.name" />
                                                }
                                                fullWidth
                                                value={body.name || ''}
                                                onChange={event => {
                                                    setBody({
                                                        ...body,
                                                        name:
                                                            event.target.value,
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-6 col-12 mb-5">
                                            <FormControl fullWidth>
                                                <InputLabel>
                                                    <LocaleMessage msg="page.articles.categories.form.label.parent" />
                                                </InputLabel>
                                                <Select
                                                    id="category-parent"
                                                    value={body.parent_id || ''}
                                                    onChange={event => {
                                                        setBody({
                                                            ...body,
                                                            parent_id:
                                                                event.target
                                                                    .value,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="">
                                                        <LocaleMessage msg="page.articles.categories.form.label.no_parent" />
                                                    </MenuItem>
                                                    {categories.map(c => (
                                                        <MenuItem
                                                            value={c.value}
                                                            key={c.value}
                                                        >
                                                            {c.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </>
                            </CardSideBordered>
                            <Button
                                className="p-3"
                                variant="contained"
                                color="primary"
                                onClick={event => handleSubmit(event)}
                                fullWidth
                                size="large"
                            >
                                <LocaleMessage msg="button.save" />
                            </Button>
                        </form>
                    </div>
                </div>
            </>
        </PageContent>
    );
}

ArticleCategoryForm.propTypes = {
    match: PropTypes.object.isRequired,
};
